// import React, { useEffect, createContext, useContext } from "react";
// import { useSelector } from "react-redux";
import styles from "../components/sections/admin/site-settings/components/style/Themes.module.css";
// import { isValidColorCode, rgba } from "../helpers";
// import { classNames } from "../helpers/classNames";

// // Context
// const ThemeContext = createContext();

// // Theme applying logic
// // export const applyTheme = (appliedTheme) => {
// //   try {
// //     if (!appliedTheme?.colors) return;

// //     const styleSheetId = "dynamic-theme-styles";
// //     let styleTag = document.getElementById(styleSheetId);
// //     if (!styleTag) {
// //       styleTag = document.createElement("style");
// //       styleTag.id = styleSheetId;
// //       document.head.appendChild(styleTag);
// //     }

// //     let hoverStyles = "";

// //     Object.entries(appliedTheme.colors).forEach(([type, variantObj]) => {
// //       Object.entries(variantObj).forEach(([variant, colorList]) => {
// //         const isHover = variant.includes("hover");

// //         colorList.forEach((colorObj) => {
// //           Object.entries(colorObj).forEach(([className, colorValue]) => {
// //             let cssColor;

// //             if (typeof colorValue === "string") {
// //               cssColor = colorValue;
// //             } else if (
// //               typeof colorValue === "object" &&
// //               colorValue.r !== undefined &&
// //               colorValue.g !== undefined &&
// //               colorValue.b !== undefined
// //             ) {
// //               const a = colorValue.a !== undefined ? colorValue.a : 1;
// //               cssColor = `rgba(${colorValue.r}, ${colorValue.g}, ${colorValue.b}, ${a})`;
// //             }

// //             if (!cssColor) return;

// //             if (isHover) {
// //               let property;
// //               if (type === "text") property = "color";
// //               else if (type === "bg") property = "background-color";
// //               else if (type === "border") property = "border-color";

// //               const escapedClass = className.replace(/:/g, "\\:");

// //               hoverStyles += `
// //                 .${escapedClass}:hover {
// //                   ${property}: ${cssColor} !important;
// //                 }
// //               `;
// //             } else {
// //               const selector = `.${className}`;
// //               document.querySelectorAll(selector).forEach((el) => {
// //                 if (type === "text") el.style.color = cssColor;
// //                 else if (type === "bg") el.style.backgroundColor = cssColor;
// //                 else if (type === "border") el.style.borderColor = cssColor;
// //               });
// //             }
// //           });
// //         });
// //       });
// //     });

// //     styleTag.innerHTML = hoverStyles;
// //   } catch (error) {
// //     console.error("applyTheme error:", error);
// //   }
// // };

// // Provider Component
// export const ThemeProvider = ({ children }) => {
//   const { appliedTheme } = useSelector((state) => state?.themeProvider);

//   //   useEffect(() => {
//   //     applyTheme(appliedTheme);

//   //     const root = document.getElementById("root");
//   //     if (!root) return;

//   //     const observer = new MutationObserver(() => {
//   //       applyTheme(appliedTheme);
//   //     });

//   //     observer.observe(root, {
//   //       childList: true,
//   //       subtree: true,
//   //     });

//   //     return () => {
//   //       observer.disconnect();
//   //     };
//   //   }, [JSON.stringify(appliedTheme?.colors)]);

//   console.log(
//     Object.keys(
//       Object.assign(
//         {},
//         ...Object.keys(appliedTheme?.colors)
//           .map((groupKey) =>
//             Object.keys(appliedTheme?.colors[groupKey])?.map((key) =>
//               appliedTheme?.colors[groupKey][key]?.map((item) =>
//                 Object.entries(item || {}).map(([key, value]) => ({
//                   [`--${key}`]: value,
//                 }))
//               )
//             )
//           )
//           ?.flat(Infinity)
//       )
//     )
//   );

//   return (
//     <ThemeContext.Provider value={{ appliedTheme }}>
//       <div
//         style={Object.assign(
//           {},
//           ...Object.keys(appliedTheme?.colors)
//             .map((groupKey) =>
//               Object.keys(appliedTheme?.colors[groupKey])?.map((key) =>
//                 appliedTheme?.colors[groupKey][key]?.map((item) =>
//                   Object.entries(item || {}).map(([key, value]) => ({
//                     [`--${key}`]:
//                       isValidColorCode(value) === "HEX" ? value : rgba(value),
//                   }))
//                 )
//               )
//             )
//             ?.flat(Infinity)
//         )}
//         className={classNames("root-provider", Object.values(styles).join(" "))}
//       >
//         {children}
//       </div>
//     </ThemeContext.Provider>
//   );
// };

// // Custom hook to use theme
// export const useTheme = () => useContext(ThemeContext);

// ThemeProvider.jsx
import React, { useEffect, createContext, useContext } from "react";
import { useSelector } from "react-redux";
import { isValidColorCode, rgba } from "../helpers";

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const { appliedTheme } = useSelector((state) => state?.themeProvider);

  useEffect(() => {
    if (!appliedTheme?.colors) return;

    const root = document.documentElement;

    Object.keys(appliedTheme.colors).forEach((colorGroup) => {
      Object.keys(appliedTheme.colors[colorGroup]).forEach((variant) => {
        appliedTheme.colors[colorGroup][variant].forEach((colorObj) => {
          Object.entries(colorObj).forEach(([key, value]) => {
            const cssValue =
              isValidColorCode(value) === "HEX" ? value : rgba(value);
            root.style.setProperty(`--${key}`, cssValue);
          });
        });
      });
    });
  }, [appliedTheme]);

  console.log(appliedTheme?.colors);

  //   const data = appliedTheme?.colors;

  //   const cssVariables = {};
  //   const classStyles = [];

  //   function toCSSVarName(className) {
  //     return className.replace(/:/g, "-").replace(/\./g, "");
  //   }

  //   function getColorValue(value) {
  //     if (typeof value === "string") return value;
  //     const { r, g, b, a } = value;
  //     return `rgba(${r}, ${g}, ${b}, ${a})`;
  //   }

  //   ["bg", "text"].forEach((type) => {
  //     ["normal", "hover"].forEach((state) => {
  //       data[type][state].forEach((item) => {
  //         const className = Object.keys(item)[0];
  //         const cssVarName = `--${toCSSVarName(className)}`;
  //         const colorValue = getColorValue(item[className]);

  //         cssVariables[cssVarName] = colorValue;

  //         // Root style
  //         classStyles.push(
  //           `:global(.theme-root .${className.replace(":", "\\:")}) {\n  ${
  //             type === "bg" ? "background-color" : "color"
  //           }: var(${cssVarName});\n}`
  //         );
  //       });
  //     });
  //   });

  //   // Root :global variables
  //   let rootVars = `:global(.theme-root) {\n`;
  //   Object.entries(cssVariables).forEach(([key, val]) => {
  //     rootVars += `  ${key}: ${val};\n`;
  //   });
  //   rootVars += `\n  /* Optional fallback */\n  background-color: var(--bg-primary);\n  color: var(--text-primary);\n}\n`;

  //   const resultCSS = `${rootVars}\n${classStyles.join("\n\n")}`;
  //   console.log(resultCSS);

  return (
    <ThemeContext.Provider value={{ appliedTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
